import React from 'react'
import Svg from './Svg'
export const SvgVerticalDots = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M14.014 5.93c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8.8 1.8 1.8 1.8 1.8-.8 1.8-1.8zM14.014 11.83c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8.8 1.8 1.8 1.8 1.8-.8 1.8-1.8zM14.014 17.83c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8.8 1.8 1.8 1.8c1-.1 1.8-.9 1.8-1.8z" />
  </Svg>
))
SvgVerticalDots.isIcon = true
export default SvgVerticalDots
